import { useIsEnabled } from '../../../hooks/use-is-enabled';
import { Tag } from '../types';
import { useIsActive } from './use-is-active';
import { useTagSchema } from './use-tag-schema';

export const useTagState = (tag: Tag) => {
	const isActive = useIsActive(tag);
	const isEnabled = useIsEnabled(tag);
	const schema = useTagSchema(tag);

	return { isActive, isEnabled, schema };
};
